import { api } from "./api";

export const BusCreate = async (data) => {
  return await api.post("bus/add", data);
};
export const BusView = async () => {
  return await api.get("bus/view");
};
export const GetBus = async (addUrl = "") => {
  let url = `/bus/list?${addUrl}`;
  return await api.get(url);
};
export const GetBusStudent = async (addUrl = "") => {
  let url = `/student/bus/list?${addUrl}`;
  return await api.get(url);
};
export const BusUpdate = async (data) => {
  return await api.post("bus_update", data);
};

export const BusDelete = async (id) => {
  return await api.get(`bus_delete/${id}`);
};

export const BusRoute = async () => {
  const url = `route/list`;
  return await api.get(url);
};

export const BusStudent = async () => {
  return await api.get(`bus/view`);
};

export const BusRouteAdd = async (data) => {
  return await api.post("bus/route/add", data);
};

export const BusStudentCreate = async (data) => {
  return await api.post("bus/student/add", data);
};
export const BusFeeUpdate = async (data) => {
  return await api.post("/bus/fee/update", data);
};

export const BusRouteUpdate = async (data) => {
  return await api.post("bus/route/update", data);
};

export const BusRouteDelete = async (id) => {
  return await api.get(`bus/route/delete/${id}`);
};

export const BusFee = async (id) => {
  return await api.get(`bus_report/${id}`);
};


